<template>
	<div class="app-nav-top">
		<nav>
			<ul v-if="canNavigate" class="menu">
				<li class="home">
					<router-link to="/console/">Cognitive Cloud</router-link>
				</li>
				<li>
					<router-link to="/console/usage" :class="$route.name">Usage</router-link>
				</li>
				<li>
					<router-link to="/console/payment" :class="$route.name">Payment info</router-link>
				</li>
				<li>
					<router-link to="/console/prices" :class="$route.name">Prices</router-link>
				</li>
				<li>
					<router-link to="/console/test-runner-dashboard" :class="$route.name">Test Run Dashboard</router-link>
				</li>
				<li v-if="isAdmin">
					<router-link to="/console/pricing" :class="$route.name">Pricing</router-link>
				</li>
				<li v-if="isAdmin">
					<router-link to="/console/bonus" :class="$route.name">Bonus</router-link>
				</li>
			</ul>
			
			<settings-dropdown v-if="canNavigate" :isAdmin="isAdmin" />
		</nav>
	</div>
</template>

<script>
import SettingsDropdown from './SettingsDropdown';

export default {
	name: 'Navigation',
	components: {
		SettingsDropdown,
	},
	computed: {
		isAdmin() {
			return this.$store.state.authData.isAdmin;
		},
		canNavigate() {
			return this.$store.state.authData.canNavigate;
		},
	},
};
</script>
